import { LOCALITIES } from "@/config";
import { CtaButton } from "@/components/Cta";
import { MapPin } from "lucide-react";

export const Localities = () => (
  <section data-testid="localities" className="nb-section bg-surface2">
    <div className="nb-shell">
      <p className="nb-eyebrow">Coverage</p>
      <h2 className="nb-h2 mt-4">Where NightBay works</h2>
      <p className="nb-sub mt-6 max-w-[68ch]">
        We're starting with ten Bengaluru localities and going deep in each one rather than thin
        across the city.
      </p>

      <ul className="mt-8 flex flex-wrap gap-2.5">
        {LOCALITIES.map((l) => (
          <li key={l}>
            <span
              data-testid={`locality-chip-${l.toLowerCase().replace(/\s+/g, "-")}`}
              className="inline-flex items-center gap-1.5 rounded-full border border-lineStrong bg-surface3 px-4 py-2 text-sm text-ink2"
            >
              <MapPin size={14} className="text-brand" aria-hidden="true" />
              {l}
            </span>
          </li>
        ))}
      </ul>

      <p className="mt-8 max-w-[68ch] text-sm text-ink3">
        Somewhere else? Leave your number anyway — we open a new locality when we have both a few bays
        and a few drivers asking for it.
      </p>
      <div className="mt-8">
        <CtaButton side="renter" testId="localities-cta">
          Find a spot near me
        </CtaButton>
      </div>
    </div>
  </section>
);
